
import React, { FC } from 'react'
import _ from 'lodash'
import { useMediaQuery, Theme } from '@material-ui/core'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Thumbs, Mousewheel, Pagination, Autoplay } from "swiper";
import 'swiper/swiper.min.css';
import "./navigation.css";
import "./pagination.css";
import './swiperWithThumbs.css'

// install Swiper's Thumbs component
SwiperCore.use([Thumbs, Navigation, Mousewheel, Pagination, Autoplay]);


type SwiperWithThumbsProps = {
    images: string[]
    hqImages?: string[]
    alt: string
    id?: string
}

export const SwiperWithThumbs: FC<SwiperWithThumbsProps> = ({ images, hqImages, alt, id }) => {
    // store thumbs swiper instance
    const [thumbsSwiper, setThumbsSwiper] = React.useState(null)
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))

    React.useEffect(() => {
        if (isMobile) setThumbsSwiper(null);
    }, [isMobile]);

    React.useEffect(() => () => { setThumbsSwiper(null) }, []);

    return (
        <div className='swiper-with-thumbs'>
            { !isMobile &&
                <div className="thumbs-swiper-container">
                    <div className="swiper-wrapper">

                        <Swiper
                            onSwiper={setThumbsSwiper}
                            direction="vertical"
                            spaceBetween={6}
                            slidesPerView="auto"
                            navigation={{
                                nextEl: `.swiper-button-next-${id}`,
                                prevEl: `.swiper-button-prev-${id}`
                            }}
                            watchSlidesVisibility
                            watchSlidesProgress
                            freeMode={true}
                            touchRatio={0.2}
                        >
                            {images.map((slide, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <img src={slide} alt={alt} />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </div>
                    <div className={`swiper-button-next swiper-button-next-${id}`}></div>
                    <div className={`swiper-button-prev swiper-button-prev-${id}`}></div>
                </div>
            }

            <div className="main-swiper-container">
                <div className="raz-slideshow swiper-wrapper">

                    <Swiper
                        key={`swiper-${id}-${isMobile ? 'm' : 'd'}`}
                        thumbs={ isMobile ? null : { swiper: thumbsSwiper }}
                        direction="horizontal"
                        slidesPerView={1}
                        spaceBetween={6}
                        mousewheel={true}
                        navigation={{
                            nextEl: `.swiper-button-next-${id}`,
                            prevEl: `.swiper-button-prev-${id}`
                        }}
                        pagination={{ clickable: true }}
                        loop={images.length > 1 ? true : false}
                        autoplay={{delay: 3000 }}


                    >
                        {(_.isEmpty(hqImages) ? images : hqImages).map((slide, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <img src={slide} alt={alt} />
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        </div>
    )
}
